import { ApplicationStatus } from "shared/types";

export const getFilterDisplayName = (filter: string) => {
  switch (filter) {
    case ApplicationStatus.Pending:
      return "Invited";
    case ApplicationStatus.Approved:
      return "Approved";
    case ApplicationStatus.ConditionalApproved:
      return "Approved conditionally";
    case ApplicationStatus.Rejected:
      return "Declined";
    case ApplicationStatus.Submitted:
      return "Pending decision";
    case ApplicationStatus.Started:
      return "In progress";
    case ApplicationStatus.Canceled:
      return "Canceled";
    default:
      return filter;
  }
};
